import React, { Component } from "react";
import {
  message,
  PageHeader,
  Spin,
  Row,
  Col,
  Select,
  Popconfirm,
  Alert,
  Input,
} from "antd";
import {
  MensajeError,
  dineroDisabledMask,
  Form,
  SelectItem,
  FormItem,
  InputNumberItem,
  round2Decimals,
  DatePickerItem,
  ButtonItem,
  InputItem,
  ModalItem,
  NotificacionPolizas,
  ErrorItem,
  SwitchItem,
} from "../../../../Components/Items";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import InfoCard from "../../../../Components/InfoCard";
import {
  CalendarOutlined,
  UserOutlined,
  IdcardOutlined,
  PhoneOutlined,
  ContactsOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  CarOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import MandarCorreoComplemento from "../MandarCorreoComplemento/MandarCorreoComplemento";
import MandarCorreoPago from "../MandarCorreoPago/MandarCorreoPago";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import complementoPdf from "../../../../Pdf/complementoPdf";
import cobroPdf from "../../../../Pdf/cobroPdf";
import cobroFernandoPdf from "../../../../Pdf/cobroFernandoPdf";
import SelectProveedoresItem from "../../../../Components/SelectProveedoresItem";
pdfMake.vfs = pdfFonts.pdfMake.vfs;


const { Option } = Select;

moment.locale("es");

const CLAVES_FORMA_PAGO_CON_CUENTA = [2, 3, 4, 5, 28, 29];
const CAMPOS_CUENTA_ORDENANTE = ["ctaOrdenante", "rfcEmisorCtaOrd", "nomBancoOrdExt"];
const CAMPOS_CUENTA_BENEFICIARIO = ["ctaBeneficiario", "rfcEmisorCtaBen"];
const CAMPOS_DATOS_CUENTA = [...CAMPOS_CUENTA_ORDENANTE, ...CAMPOS_CUENTA_BENEFICIARIO];

class CobrarVenta extends Component {
  formRef = React.createRef();
  formRefCuentaCliente = React.createRef();
  state = {
    loading: false,
    datosVenta: undefined,
    todasBancos: null,
    objetoBancos: null,
    objetoFormasDePago: null,
    todasFormasDePago: null,
    objetoMonedas: null,
    todasMonedas: null,
    modalCorreo: false,
    modalCorreoId: null,
    modalCorreoPago: false,
    notasDeCreditoPendiente: [],
    objetoNotasPendiente: null,
    anticiposPendientes: [],
    objetoAnticiposPendientes: null,
    abonosPendientesClientes: [],
    objetoAbonosPendientes: null,
    id: this.props.location.state.id,
    factorajeFinancieroCXC: false,
    clienteFactoraje: false,
    cuentasIncobrables: false,
    cuentasAjusteCentavosCxC: false,
    pagarConIncobrable: false,
    pagarConAjusteCentavos: false,
    pagarConNotas: false,
    todasCuentasCliente: [],
    objetoCuentasCliente: null,
    cuentaClienteSeleccionada: undefined,
    cuentaPredeterminadaCliente: null,
    modalAgregarCuentaCliente: false,
    loadingCuentaCliente: false,
    todasBancosSat : [],
    nombreCliente: '',
  };
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "bancos/selectBancos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasBancos: res.data });
          this.setState({
            objetoBancos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.banco}
                </Option>
              );
            }),
          });
        }
      });
      await axios
        .post(
          "bancosSat/selectBancosSat",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken },
        )
        .then((res) => {
          if (res.data.status !== 404) {
            this.setState({ todasBancosSat: res.data });
          }
        });
    await axios
      .post(
        "cajaefectivo/selectCajaEfectivo",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasBancos: this.state.todasBancos && this.state.todasBancos?.length > 0 ? [...this.state.todasBancos, ...res.data] : res.data });
          this.setState({
            objetoBancos: this.state.objetoBancos && this.state.objetoBancos?.length > 0 ? [...this.state.objetoBancos, ...res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + (value.banco ? ' - ' + value.banco : '')}
                </Option>
              );
            })] : res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + (value.banco ? ' - ' + value.banco : '')}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "formasdepago/selectFormasDePago",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasFormasDePago: res.data });
          this.setState({
            objetoFormasDePago: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value?.c_FormaPago + ' - ' + value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post("monedas/selectMonedas", { empresaId: this.props.empresaId }, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasMonedas: res.data });
          this.setState({
            objetoMonedas: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviacion}
                </Option>
              );
            }),
          });
        }
      });
    let clienteIdVenta = null;
    await axios
      .post(
        "cuentasporcobrar/datosCobrarVenta",
        {
          empresaId: this.props.empresaId,
          ventaId: this.state.id,
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontro informacion de la venta");
        } else {
          const datosVenta = res.data[0];
          const cliente = datosVenta.cliente;
          clienteIdVenta = cliente?._id;

          const nombreCliente = cliente.nombre
            ? cliente.nombre +
            " " +
            cliente.apellidoPaterno +
            " " +
            cliente.apellidoMaterno
            : cliente.razonSocial
          const cuentas = cliente.cuentasBancoCliente || [];
          const bancoIdDefault = res.data[0].cliente.bancoId;
          const extraBanco = {};
          if (bancoIdDefault) {
            const banco = this.state.todasBancos?.find(b => b._id?.toString() === bancoIdDefault?.toString());
            if (banco) {
              extraBanco.ctaBeneficiario = banco.ctaBeneficiario;
              extraBanco.rfcEmisorCtaBen = banco.rfcEmisorCtaBen;
            }
          }
          this.formRef.current.setFieldsValue({ monedaId: res.data[0].monedaId, tipoDeCambioVenta: res.data[0].tipoDeCambio, tipoDeCambioPago: res.data[0].tipoDeCambio, bancoId: bancoIdDefault, formaDePagoId: cliente?.formaDePagoId || "6125149afe07662acc100d58", ...extraBanco })
          this.setState({
            nombreCliente: nombreCliente,
            datosVenta: res.data[0],
            anticiposPendientes: res.data.anticiposPendientes,
            objetoAnticiposPendientes: res.data.anticiposPendientes.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {moment(value.fechaFactura).format('L') + " - " + dineroDisabledMask(value.totalPagar - (value.totalPagadoAnticipos || 0)) + ' - ' + value.moneda.abreviacion}
                </Option>
              );
            }),
            abonosPendientesClientes: res.data.abonosPendientesClientes,
            objetoAbonosPendientes: res.data.abonosPendientesClientes.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {moment(value.fechaPago).format('L') + " - " + dineroDisabledMask(value.monto - (value.totalPagadoAbono || 0)) + ' - ' + value.moneda?.abreviacion}
                </Option>
              );
            }),
            notasDeCreditoPendiente: res.data.notasDeCreditoPendiente,
            objetoNotasPendiente: res.data.notasDeCreditoPendiente.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {
                  (value.remisionSerie ? (value.remisionSerie + " - " + value.remisionNumero + " | ") : "") +
                  (value.facturaSerie ? (value.facturaSerie + " - " + value.facturaNumero + " | ") : "") +
                  moment(value.fechaFactura || value.fechaRemision).format('L') + " - " + dineroDisabledMask(value.totalPagar - value.totalPagado) + ' - ' + value.moneda.abreviacion +
                  (value.concepto ? " | " + value.concepto : "")}
                </Option>
              );
            }),
            factorajeFinancieroCXC: res.data.factorajeFinancieroCXC,
            cuentasIncobrables: res.data.cuentasIncobrables,
            cuentasAjusteCentavosCxC: res.data.cuentasAjusteCentavosCxC,
            todasCuentasCliente: cuentas,
            objetoCuentasCliente: this.construirObjetoCuentasCliente(cuentas),
          });
          this.onChangeMoneda(res.data[0].monedaId, 1)
        }
      });
    // La cuenta predeterminada se propone sola en el complemento de pago
    await this.consultarCuentaPredeterminada(clienteIdVenta);
    this.onChangeMoneda(this.formRef.current.getFieldValue('monedaId'), 2)
    this.setState({ loading: false });
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    if (values.pagarConNotas) {
      const notaCredito = this.state.notasDeCreditoPendiente.find((valueTodasNotas) => valueTodasNotas._id.toString() === values.notaId.toString())
      // Contra el saldo (no contra el total de la nota) y redondeado, igual que el backend.
      if (values.monto > round2Decimals(notaCredito.totalPagar - (notaCredito.totalPagado || 0))) {
        return message.info('No se puede pagar mas del saldo pendiente de la nota de credito')
      }
    }
    if (values.pagarConAnticipo) {
      const anticipo = this.state.anticiposPendientes.find((valueTodasAnticipos) => valueTodasAnticipos._id.toString() === values.anticipoId.toString())
      if (values.monto > round2Decimals(anticipo.totalPagar - (anticipo.totalPagadoAnticipos || 0))) {
        return message.info('No se puede pagar mas del saldo pendiente del anticipo')
      }
    }
    if (values.pagarConAbono) {
      const abonoCliente = this.state.abonosPendientesClientes.find((valueTodasAbonos) => valueTodasAbonos._id.toString() === values.abonoId.toString())
      // Redondeado igual que el backend: la resta en flotante puede dar 680.1999999999999
      // y rechazar un monto de 680.20 que sí cabe.
      if (values.monto > round2Decimals(abonoCliente.monto - (abonoCliente.totalPagadoAbono || 0))) {
        return message.info('No se puede pagar mas del saldo pendiente del abono')
      }
    }

    if (values.pagarConFactoraje) {
      const equivalencia = values.tipoDeCambioPago / values.tipoDeCambioVenta
      let totalPagar = this.state.datosVenta?.totalPagar || 0;
      let totalPagado =
        this.state.datosVenta?.totalPagado || 0;

      const saldoPendiente = round2Decimals(
        (totalPagar - totalPagado) / equivalencia
      );
      if (round2Decimals(values.monto + values.montoFactoraje) > saldoPendiente) {
        return message.info('No se puede pagar mas del saldo pendiente de la venta con factoraje')
      }
    }

    if (values.monedaId && values.monedaId === this.state.datosVenta?.monedaId) {
      if (round2Decimals(values.tipoDeCambioVenta) !== round2Decimals(values.tipoDeCambioPago)) {
        return message.error('El tipo de cambio del pago debe ser igual al de la venta cuando la moneda es la misma')
      }
    }
   
    const valuesEnviar = { ...values };
    if (!this.requiereDatosCuenta(values.formaDePagoId)) {
      CAMPOS_DATOS_CUENTA.forEach((campo) => delete valuesEnviar[campo]);
    } else if (!this.state.cuentaClienteSeleccionada) {
      // Sin cuenta del cliente no hay de donde sacar los datos del ordenante
      CAMPOS_CUENTA_ORDENANTE.forEach((campo) => delete valuesEnviar[campo]);
    }

    this.setState({ loading: true });
    axios
      .post(
        "cuentasporcobrar/cobrarVenta",
        {
          ...valuesEnviar,
          empresaId: this.props.empresaId,
          ventaId: this.state.id,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Se ha registrado un pago");

          if (this.state.datosVenta.factura && !this.state.datosVenta.cuentasXC && !values.pagarConIncobrable && !values.pagarConAjusteCentavos && !values.pagarConNotas) {

            if (window.registrarMovimiento) {
              const dataSat = res.data.respuestaComplemento.dataSat;
              const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'F') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Rfc + ' - ' + dataSat.Receptor.Nombre + ' )';

              window.registrarMovimiento({
                titulo: 'Complemento de Pago Emitido',
                mensaje: `${nombreArchivo} - Haga click para descargar`,
                icono: 2,
                onClick: () => {
                  var xmltext = res.data.respuestaComplemento.data.cfdi;

                  var filename = nombreArchivo + ".xml";
                  var pom = document.createElement("a");
                  var bb = new Blob([xmltext], { type: "text/plain" });

                  pom.setAttribute("href", window.URL.createObjectURL(bb));
                  pom.setAttribute("download", filename);

                  pom.dataset.downloadurl = [
                    "text/plain",
                    pom.download,
                    pom.href,
                  ].join(":");
                  pom.draggable = true;
                  pom.classList.add("dragout");

                  pom.click();

                  const pdf = complementoPdf(res.data);

                  pdfMake.createPdf(pdf).download(nombreArchivo + ".pdf");
                },
              });
            }

            NotificacionPolizas(res.data.polizasId)
            this.setState({ modalCorreo: true, modalCorreoId: res.data.pagoId })

          } else {
            if (window.registrarMovimiento) {
              const dataSat = res.data.respuestaComplemento.dataSat;
              const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'F') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Nombre + ' )';

              window.registrarMovimiento({
                titulo: 'Pago Emitido',
                mensaje: `${nombreArchivo} - Haga click para descargar`,
                icono: 2,
                onClick: () => {
                  const pdf = (this.props.empresaId.toString() === '677c1e57f38e06c3032974fb') ? cobroFernandoPdf(res.data) : cobroPdf(res.data);

                  pdfMake.createPdf(pdf).download(nombreArchivo + ".pdf");
                },
              });
            }

            NotificacionPolizas(res.data.polizasId)
            this.setState({ modalCorreoPago: true, modalCorreoId: res.data.pagoId })
          }

        } else if (res.data.success === 1) {
          MensajeError({
            message: res.data.errorTimbrado?.titulo || res.data.message || "No se pudo efectuar el pago",
            description: res.data.errorTimbrado?.mensaje || res.data.description,
            detalleTecnico: res.data.errorTimbrado?.detalleTecnico,
          });
        } else {
          // El controlador manda el motivo en `message` para decenas de validaciones
          // propias (saldo insuficiente, banco de otra moneda, cuenta contable
          // faltante). El texto de respaldo es sólo para cuando no vino nada.
          message.error(res.data.message || "Hubo un error y no se efectuo el pago");
        }
        this.setState({ loading: false });
      });
  }
  cerrarMandarCorreoComplemento() {
    this.setState({
      modalCorreo: false,
      modalCorreoId: null,
    });
    this.formRef.current.resetFields();
    this.atras();
  }

  cerrarMandarCorreoPago() {
    this.setState({
      modalCorreoPago: false,
      modalCorreoId: null,
    });
    this.formRef.current.resetFields();
    this.atras();
  }

  onChangeNotaDeCredito(notaId) {
    if (notaId) {
      const notaCredito = this.state.notasDeCreditoPendiente.find((valueTodasNotas) => valueTodasNotas._id.toString() === notaId.toString())
      this.formRef.current.setFieldsValue({ monedaId: notaCredito.monedaId, tipoDeCambioPago: notaCredito.tipoDeCambio })
    }
  }

  onChangeAnticipo(anticipoId) {
    if (anticipoId) {
      const anticipo = this.state.anticiposPendientes.find((valueTodasAnticipos) => valueTodasAnticipos._id.toString() === anticipoId.toString())
      this.formRef.current.setFieldsValue({ monedaId: anticipo.monedaId, tipoDeCambioPago: anticipo.tipoDeCambio })
    }
  }

  onChangeAbono(abonoId) {
    if (abonoId) {
      const abono = this.state.abonosPendientesClientes.find((valueTodasAbonos) => valueTodasAbonos._id.toString() === abonoId.toString())
      this.formRef.current.setFieldsValue({ monedaId: abono.monedaId, tipoDeCambioPago: abono.tipoDeCambioPago, fechaPago: abono.fechaPago ? moment(abono.fechaPago) : null })
    }
  }

  onChangeMoneda(value, tipo, fecha) {
    if (value && value !== "60c7e4396465ad440c41c15a") {
      axios
        .post(
          "tipoDeCambio/obtenerTipoDeCambio",
          {
            monedaId: value,
            empresaId: this.props.empresaId,
            fecha: fecha || undefined,
          },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            if (res.data.monedaString && res.data.dia) {
              message.success(
                "Se ha obtenido el tipo de cambio" +
                (res.data.monedaString ? " " + res.data.monedaString : "") +
                (res.data.dia ? " del día " + res.data.dia : "")
              );
            }
            if (tipo === 1) {
              this.formRef.current.setFieldsValue({
                tipoDeCambioVenta: res.data.tipoDeCambio,
              });
            } else {
              this.formRef.current.setFieldsValue({
                tipoDeCambioPago: res.data.tipoDeCambio,
              });
            }
          }
        });
    } else {
      this.formRef.current.setFieldsValue({ tipoDeCambioPago: 1 });
    }
  }

  requiereDatosCuenta(formaDePagoId) {
    // Mientras no cargue el catalogo no atenuamos nada
    if (!this.state.todasFormasDePago) return true;
    if (!formaDePagoId) return false;
    const formaDePago = this.state.todasFormasDePago.find(
      (valueFormas) => valueFormas._id.toString() === formaDePagoId.toString()
    );
    return CLAVES_FORMA_PAGO_CON_CUENTA.includes(Number(formaDePago?.c_FormaPago));
  }

  // bancoSatId llega como id desde datosCobrarVenta, pero ya populado
  // desde cuentaBancoPredeterminadaCliente. Se resuelven ambos casos
  obtenerBancoSatDeCuenta(cuenta) {
    const bancoSat = cuenta?.bancoSatId;
    if (bancoSat && typeof bancoSat === "object") return bancoSat;
    return this.state.todasBancosSat?.find(
      (b) => b._id.toString() === bancoSat?.toString()
    );
  }

  // Aplica una cuenta del cliente a los campos del ordenante. mostrarMensaje se
  // omite cuando la seleccion es automatica (cuenta predeterminada al cargar)
  seleccionarCuentaCliente(cuenta, mostrarMensaje) {
    const bancoInfo = this.obtenerBancoSatDeCuenta(cuenta);
    this.setState({ cuentaClienteSeleccionada: cuenta?.cuenta });
    this.formRef.current.setFieldsValue({
      ctaOrdenante: cuenta?.cuenta,
      rfcEmisorCtaOrd: bancoInfo?.rfc || "",
      nomBancoOrdExt: bancoInfo?.nombreCorto || "",
    });
    if (mostrarMensaje) message.success("Datos del cliente cargados");
  }

  // predeterminada se pasa explicitamente cuando viene del endpoint, porque el
  // setState que la guarda todavia no se refleja al construir las opciones
  construirObjetoCuentasCliente(cuentas, predeterminada) {
    const cuentaPredeterminada =
      predeterminada !== undefined ? predeterminada : this.state.cuentaPredeterminadaCliente;
    const esPredeterminada = (cta) =>
      cuentaPredeterminada
        ? cta.cuenta?.toString() === cuentaPredeterminada.cuenta?.toString()
        : !!cta.predeterminada;

    // La cuenta predeterminada del cliente se muestra primero
    const cuentasOrdenadas = [...(cuentas || [])].sort(
      (a, b) => (esPredeterminada(b) ? 1 : 0) - (esPredeterminada(a) ? 1 : 0)
    );
    return cuentasOrdenadas.map((cta, index) => {
      const bancoInfo = this.obtenerBancoSatDeCuenta(cta);

      const labelText = `${cta.cuenta}${cta.descripcion ? ` - ${cta.descripcion}` : ""} (${bancoInfo?.nombreCorto || 'Sin Banco'})`;

      return (
        <Option
          value={cta.cuenta}
          key={index}
          rfc={bancoInfo?.rfc}
          nombrebanco={bancoInfo?.nombreCorto}
        >
          {labelText}
        </Option>
      );
    });
  }

  async consultarCuentaPredeterminada(clienteId) {
    if (!clienteId) return;
    await axios
      .post(
        "clientes/cuentaBancoPredeterminadaCliente",
        { empresaId: this.props.empresaId, clienteId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2 || !res.data.data) return;
        const cuentaPredeterminada = res.data.data;
        this.setState({
          cuentaPredeterminadaCliente: cuentaPredeterminada,
          objetoCuentasCliente: this.construirObjetoCuentasCliente(
            this.state.todasCuentasCliente,
            cuentaPredeterminada
          ),
        });
        this.seleccionarCuentaCliente(cuentaPredeterminada, false);
      })
      .catch(() => {
        // Sin cuenta predeterminada la pantalla funciona igual, solo no se propone ninguna
      });
  }

  onSelectCuentaGuardada = (cuentaValue, option) => {
    this.setState({ cuentaClienteSeleccionada: cuentaValue });
    if (option) {
      this.formRef.current.setFieldsValue({
        ctaOrdenante: cuentaValue,
        rfcEmisorCtaOrd: option.rfc || "",
        nomBancoOrdExt: option.nombrebanco || ""
      });
      message.success("Datos del cliente cargados");
    }
  };

  abrirAgregarCuentaCliente() {
    if (!this.state.datosVenta?.cliente?._id) {
      return message.info("Espere a que termine de cargar la informacion del cliente");
    }
    this.setState({ modalAgregarCuentaCliente: true });
  }

  cerrarAgregarCuentaCliente() {
    this.setState({ modalAgregarCuentaCliente: false });
    this.formRefCuentaCliente.current?.resetFields();
  }

  onFinishFailedCuentaCliente(e) {
    ErrorItem(e);
  }

  onFinishCuentaCliente(values) {
    const clienteId = this.state.datosVenta?.cliente?._id;
    if (!clienteId) {
      return message.error("No se encontro el cliente de la venta");
    }

    const cuentasActuales = this.state.todasCuentasCliente || [];

    if (
      cuentasActuales.some(
        (cta) => cta.cuenta?.toString().trim() === values.cuenta?.toString().trim()
      )
    ) {
      return message.info("El cliente ya tiene registrada esa cuenta");
    }

    const cuentaNueva = {
      descripcion: values.descripcion,
      bancoSatId: values.bancoSatId,
      cuenta: values.cuenta,
      // Si es la primera cuenta del cliente queda como predeterminada
      predeterminada: cuentasActuales.length === 0,
    };

    this.setState({ loadingCuentaCliente: true });
    axios
      .post(
        "clientes/agregarCuentaBancoCliente",
        {
          empresaId: this.props.empresaId,
          clienteId,
          cuenta: cuentaNueva,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loadingCuentaCliente: false });
        if (res.data.success === 2) {
          message.success("Se agrego una cuenta del cliente");
          // Se usa el arreglo que devuelve el servidor para no quedarse con una copia vieja
          const cuentasBancoCliente =
            res.data.cuentasBancoCliente || [...cuentasActuales, cuentaNueva];
          const predeterminada =
            cuentasBancoCliente.find((cta) => cta.predeterminada) || null;
          const cuentaAgregada =
            cuentasBancoCliente.find(
              (cta) => cta.cuenta?.toString() === cuentaNueva.cuenta?.toString()
            ) || cuentaNueva;
          this.setState(
            {
              todasCuentasCliente: cuentasBancoCliente,
              cuentaPredeterminadaCliente: predeterminada,
              objetoCuentasCliente: this.construirObjetoCuentasCliente(
                cuentasBancoCliente,
                predeterminada
              ),
              modalAgregarCuentaCliente: false,
            },
            () => {
              this.seleccionarCuentaCliente(cuentaAgregada, true);
              this.formRefCuentaCliente.current?.resetFields();
            }
          );
        } else if (res.data.success === 1) {
          message.warning(res.data.message || "No se pudo agregar la cuenta del cliente");
        } else {
          message.error("Hubo un error y no se agrego la cuenta del cliente");
        }
      })
      .catch(() => {
        this.setState({ loadingCuentaCliente: false });
        message.error("Hubo un error y no se agrego la cuenta del cliente");
      });
  }

  atras() {
    this.props.history.goBack();
  }

  renderMonedaCard() {
    const abreviacionVenta = this.state.datosVenta?.moneda?.abreviacion || '';
    const esVentaMXN = this.state.datosVenta?.monedaId === '60c7e4396465ad440c41c15a';
    return (
      <Row gutter={[8, 0]}>
        <Col span={24}>
          {esVentaMXN ? (
            <FormItem hidden name="tipoDeCambioVenta" initialValue={1}>
              <InputNumberItem />
            </FormItem>
          ) : (
            <Row align="middle" gutter={[8, 0]}>
              <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                <FormItem
                  required
                  number
                  margin
                  label={`T.C. ${abreviacionVenta}`}
                  name="tipoDeCambioVenta"
                  type="number"
                  initialValue={1}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  <InputNumberItem
                    dinero
                    placeholder={`T.C. ${abreviacionVenta}`}
                  />
                </FormItem>
              </Col>
              <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                <div
                  style={{
                    textAlign: 'center',
                    fontSize: 11,
                    color: '#888',
                    padding: '6px 8px',
                    background: '#fafafa',
                    border: '1px dashed #e8e8e8',
                    borderRadius: 4,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  T.C. Venta: <strong style={{ color: '#555' }}>{dineroDisabledMask(this.state.datosVenta?.tipoDeCambio)}</strong>
                </div>
              </Col>
            </Row>
          )}

          <FormItem shouldUpdate noStyle>
            {({ getFieldValue }) => {
              const pagarConNotas = getFieldValue('pagarConNotas')
              const pagarConAnticipo = getFieldValue('pagarConAnticipo')
              const pagarConAbono = getFieldValue('pagarConAbono')
              const pagarConIncobrable = getFieldValue('pagarConIncobrable')
              const pagarConAjusteCentavos = getFieldValue('pagarConAjusteCentavos')
              return (
                <FormItem
                  required
                  margin
                  name="monedaId"
                  label="Moneda Pago"
                  labelCol={{ span: 9 }}
                  wrapperCol={{ span: 15 }}
                  initialValue={'60c7e4396465ad440c41c15a'}
                >
                  <SelectItem
                    placeholder="Moneda"
                    disabled={pagarConNotas || pagarConAnticipo || pagarConAbono || pagarConIncobrable || pagarConAjusteCentavos}
                    onChange={(value) => this.onChangeMoneda(value, 2)}
                  >
                    {this.state.objetoMonedas}
                  </SelectItem>
                </FormItem>
              )
            }}
          </FormItem>

          <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId || prev.pagarConNotas !== curr.pagarConNotas || prev.pagarConAnticipo !== curr.pagarConAnticipo || prev.pagarConAbono !== curr.pagarConAbono}>
            {({ getFieldValue }) => {

              const monedaId = getFieldValue('monedaId')

              const pagarConNotas = getFieldValue('pagarConNotas')

              const pagarConAnticipo = getFieldValue('pagarConAnticipo')

              const pagarConAbono = getFieldValue('pagarConAbono')

              const moneda = this.state.todasMonedas ? this.state.todasMonedas.find((valueTodasMonedas) => valueTodasMonedas._id.toString() === monedaId.toString()) : null

              return (
                <FormItem
                  required
                  number
                  margin
                  hidden={monedaId === '60c7e4396465ad440c41c15a'}
                  label={`T.C. ${moneda?.abreviacion ? moneda.abreviacion : ''}`}
                  name="tipoDeCambioPago"
                  type="number"
                  initialValue={1}
                  labelCol={{ span: 9 }}
                  wrapperCol={{ span: 15 }}
                >
                  <InputNumberItem
                    disabled={monedaId === '60c7e4396465ad440c41c15a' || pagarConNotas || pagarConAnticipo || pagarConAbono}
                    dinero
                    placeholder={`T.C. ${moneda?.abreviacion ? moneda.abreviacion : ''}`}
                  />
                </FormItem>
              )
            }}
          </FormItem>
        </Col>
      </Row>
    );
  }

  renderDatosPagoCard() {
    return (
      <Row gutter={[8, 0]}>
        <Col span={24}>
          <FormItem
            label="Fecha de Pago"
            name="fechaPago"
            required
            margin
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 17 }}
          >
            <DatePickerItem
              placeholder="Fecha de Pago"
              allowClear={false}
              showTime
              dateFormat='DD/MM/YYYY HH:mm:ss'
              onChange={(date) => {
                const monedaIdPago = this.formRef.current.getFieldValue('monedaId')
                const monedaIdVenta = this.state.datosVenta?.monedaId
                if (monedaIdVenta && monedaIdVenta !== '60c7e4396465ad440c41c15a') {
                  this.onChangeMoneda(monedaIdVenta, 1, date)
                }
                if (monedaIdPago && monedaIdPago !== '60c7e4396465ad440c41c15a') {
                  this.onChangeMoneda(monedaIdPago, 2, date)
                }
              }}
            />
          </FormItem>
          {this.state.factorajeFinancieroCXC &&
            <FormItem
              name="pagarConFactoraje"
              label="Factoraje"
              tooltip={{ title: "Cobrar la venta con factoraje financiero" }}
              margin
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 17 }}
              pattern
              valuePropName="checked"
            >
              <SwitchItem
                onChange={(checked) => {
                  if (checked) {
                    this.formRef.current.setFieldsValue({
                      pagarConNotas: false,
                      notaId: null,
                      pagarConAnticipo: false,
                      anticipoId: null,
                      pagarConAbono: false,
                      abonoId: null,
                      pagarConIncobrable: false,
                      pagarConAjusteCentavos: false,
                    })
                  }
                }}
                placeholder="Cobrar Con Factoraje"
              />
            </FormItem>
          }
          {this.state.cuentasIncobrables &&
            <FormItem
              name="pagarConIncobrable"
              label="Incobrable"
              tooltip={{ title: "Cobrar la venta como incobrable" }}
              margin
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 17 }}
              pattern
              valuePropName="checked"
            >
              <SwitchItem
                onChange={(checked) => {
                  if (checked) {
                    this.formRef.current.setFieldsValue({
                      pagarConNotas: false,
                      notaId: null,
                      pagarConAnticipo: false,
                      anticipoId: null,
                      pagarConAbono: false,
                      abonoId: null,
                      pagarConFactoraje: false,
                      pagarConAjusteCentavos: false,
                      monedaId: this.state.datosVenta?.monedaId,
                    })
                  }
                  this.setState({ pagarConIncobrable: checked })
                }}
                placeholder="Cobrar Como Incobrable"
              />
            </FormItem>
          }
          {this.state.cuentasAjusteCentavosCxC &&
            <FormItem
              name="pagarConAjusteCentavos"
              label="Ajuste Centavos"
              tooltip={{ title: "Cobrar la venta con ajuste de centavos" }}
              margin
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 17 }}
              pattern
              valuePropName="checked"
            >
              <SwitchItem
                onChange={(checked) => {
                  if (checked) {
                    this.formRef.current.setFieldsValue({
                      pagarConNotas: false,
                      notaId: null,
                      pagarConAnticipo: false,
                      anticipoId: null,
                      pagarConAbono: false,
                      abonoId: null,
                      pagarConFactoraje: false,
                      pagarConIncobrable: false,
                      monedaId: this.state.datosVenta?.monedaId,
                    })
                  }
                  this.setState({ pagarConAjusteCentavos: checked })
                }}
                placeholder="Cobrar Con Ajuste Centavos"
              />
            </FormItem>
          }
          {this.state.notasDeCreditoPendiente.length > 0 &&
            <FormItem
              name="pagarConNotas"
              label="Cobrar C/Notas"
              tooltip={{ title: "Cobrar la venta con notas de credito" }}
              margin
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 17 }}
              pattern
              valuePropName="checked"
            >
              <SwitchItem
                onChange={(checked) => {
                  if (checked) {
                    this.formRef.current.setFieldsValue({
                      pagarConFactoraje: false,
                      pagarConAnticipo: false,
                      anticipoId: null,
                      pagarConAbono: false,
                      abonoId: null,
                      pagarConIncobrable: false,
                      pagarConAjusteCentavos: false,
                    })
                  }
                  this.setState({ pagarConNotas: checked })
                }}
                placeholder="Cobrar Con Notas"
              />
            </FormItem>
          }
          {this.state.anticiposPendientes.length > 0 &&
            <FormItem
              name="pagarConAnticipo"
              label="Cobrar C/Anticipo"
              tooltip={{ title: "Cobrar la venta con un anticipo" }}
              margin
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 17 }}
              pattern
              valuePropName="checked"
            >
              <SwitchItem
                disabled
                onChange={(checked) => {
                  if (checked) {
                    this.formRef.current.setFieldsValue({
                      pagarConFactoraje: false,
                      pagarConNotas: false,
                      notaId: null,
                      pagarConAbono: false,
                      abonoId: null,
                      pagarConIncobrable: false,
                      pagarConAjusteCentavos: false,
                    })
                  }
                }}
                placeholder="Cobrar Con Anticipo"
              />
            </FormItem>
          }
          {this.state.abonosPendientesClientes.length > 0 &&
            <FormItem
              name="pagarConAbono"
              label="Cobrar C/Abono"
              tooltip={{ title: "Cobrar la venta con un abono" }}
              margin
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              pattern
              valuePropName="checked"
            >
              <SwitchItem
                onChange={(checked) => {
                  if (checked) {
                    this.formRef.current.setFieldsValue({
                      pagarConFactoraje: false,
                      pagarConNotas: false,
                      notaId: null,
                      pagarConAnticipo: false,
                      anticipoId: null,
                      pagarConIncobrable: false,
                      pagarConAjusteCentavos: false,
                    })
                  }
                }}
                placeholder="Cobrar Con Abono"
              />
            </FormItem>
          }
          <FormItem shouldUpdate noStyle>
            {({ getFieldValue }) => {
              const pagarConFactoraje = getFieldValue('pagarConFactoraje')
              if (pagarConFactoraje) {
                let tipoDeCambioVenta = getFieldValue('tipoDeCambioVenta')
                let tipoDeCambioPago = getFieldValue('tipoDeCambioPago')
                const equivalencia = tipoDeCambioPago / tipoDeCambioVenta
                let totalPagar = this.state.datosVenta?.totalPagar || 0;
                let totalPagado =
                  this.state.datosVenta?.totalPagado || 0;

                const saldoPendiente = round2Decimals(
                  (totalPagar - totalPagado) / equivalencia
                );

                return (
                  <>
                    <FormItem
                      label="Proveedor Factoraje"
                      name="proveedorFactorajeId"
                      required
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      margin
                    >
                      <SelectProveedoresItem
                        empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                        headersToken={this.props.headersToken}
                        factorajeFinancieroCXC
                        sinBorde
                        autoFocus
                        dropdownMatchSelectWidth={600}
                        width="100%"
                        placeholder="Proveedor Factoraje"
                      />
                    </FormItem>
                    <FormItem
                      required
                      number
                      margin
                      label="Monto Factoraje"
                      name="montoFactoraje"
                      type="number"
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      max={saldoPendiente}
                      tooltip={{ title: "Monto de la comisión o parte que se quedara el proveedor de factoraje. Esta se facturará como 17 - Compensación" }}
                    >
                      <InputNumberItem dinero placeholder="Monto Factoraje" />
                    </FormItem>
                  </>
                )
              }
              return null
            }}
          </FormItem>
          <FormItem shouldUpdate noStyle>
            {({ getFieldValue }) => {
              const pagarConNotas = getFieldValue('pagarConNotas')
              const pagarConAnticipo = getFieldValue('pagarConAnticipo')
              const pagarConAbono = getFieldValue('pagarConAbono')
              const pagarConIncobrable = getFieldValue('pagarConIncobrable')
              const pagarConAjusteCentavos = getFieldValue('pagarConAjusteCentavos')

              if (pagarConNotas) {
                return (
                  <FormItem
                    label="Nota"
                    name="notaId"
                    margin
                    required
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                  >
                    <SelectItem placeholder="Nota" dropdownMatchSelectWidth={false} onChange={this.onChangeNotaDeCredito.bind(this)} >
                      {this.state.objetoNotasPendiente}
                    </SelectItem>
                  </FormItem>
                )
              } else if (pagarConAnticipo) {
                return (
                  <FormItem
                    label="Anticipo"
                    name="anticipoId"
                    margin
                    required
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                  >
                    <SelectItem placeholder="Anticipo" onChange={this.onChangeAnticipo.bind(this)} >
                      {this.state.objetoAnticiposPendientes}
                    </SelectItem>
                  </FormItem>
                )
              } else if (pagarConAbono) {
                return (
                  <FormItem
                    label="Abono"
                    name="abonoId"
                    margin
                    required
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                  >
                    <SelectItem placeholder="Abono" onChange={this.onChangeAbono.bind(this)} >
                      {this.state.objetoAbonosPendientes}
                    </SelectItem>
                  </FormItem>
                )
              } else if (pagarConIncobrable || pagarConAjusteCentavos) {
                return null
              } else {
                return (
                  <>
                    <FormItem
                      label="Banco"
                      name="bancoId"
                      margin
                      required
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 15 }}
                    >
                      <SelectItem
                        placeholder="Banco"
                        onChange={(value) => {
                          if (value) {
                            const banco = this.state.todasBancos.find((banco) => banco?._id?.toString() === value?.toString())
                            if (banco) {
                              this.formRef.current.setFieldsValue({
                                ctaBeneficiario: banco.ctaBeneficiario,
                                rfcEmisorCtaBen: banco.rfcEmisorCtaBen,
                              })
                            }
                          }
                        }}
                      >
                        {this.state.objetoBancos}
                      </SelectItem>
                    </FormItem>
                    <FormItem
                      name="formaDePagoId"
                      label="F Pago"
                      //initialValue="6125149afe07662acc100d58"
                      margin
                      required
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 15 }}
                    >
                      <SelectItem placeholder="Forma de Pago">
                        {this.state.objetoFormasDePago}
                      </SelectItem>
                    </FormItem>
                  </>
                )
              }

            }}
          </FormItem>
          <Row gutter={[8, 0]} align="middle">
            <Col span={14} xs={24} sm={24} lg={14} xl={14}>
              <FormItem noStyle shouldUpdate>
                {({ getFieldValue }) => {
                  let tipoDeCambioVenta = getFieldValue('tipoDeCambioVenta')
                  let tipoDeCambioPago = getFieldValue('tipoDeCambioPago')
                  const pagarConNotas = getFieldValue('pagarConNotas')
                  const pagarConAnticipo = getFieldValue('pagarConAnticipo')
                  const pagarConAbono = getFieldValue('pagarConAbono')

                  let saldoPendiente = 0

                  if (pagarConNotas) {
                    const notaId = getFieldValue('notaId')

                    if (notaId) {
                      const notaCredito = this.state.notasDeCreditoPendiente.find((valueTodasNotas) => valueTodasNotas._id.toString() === notaId.toString())

                      saldoPendiente = round2Decimals(notaCredito.totalPagar - notaCredito.totalPagado)
                    }


                  } else if (pagarConAnticipo) {
                    const anticipoId = getFieldValue('anticipoId')

                    if (anticipoId) {
                      const anticipo = this.state.anticiposPendientes.find((valueTodasAnticipos) => valueTodasAnticipos._id.toString() === anticipoId.toString())

                      saldoPendiente = round2Decimals(anticipo.totalPagar - (anticipo.totalPagadoAnticipos || 0))
                    }

                  } else if (pagarConAbono) {
                    const abonoId = getFieldValue('abonoId')

                    if (abonoId) {
                      const abono = this.state.abonosPendientesClientes.find((valueTodasAbonos) => valueTodasAbonos._id.toString() === abonoId.toString())

                      saldoPendiente = round2Decimals(abono.monto - (abono.totalPagadoAbono || 0))
                    }

                  } else {
                    const equivalencia = tipoDeCambioPago / tipoDeCambioVenta
                    let totalPagar = this.state.datosVenta?.totalPagar || 0;
                    let totalPagado =
                      this.state.datosVenta?.totalPagado || 0;

                    saldoPendiente = round2Decimals(
                      (totalPagar - totalPagado) / equivalencia
                    );
                  }


                  return (
                    <FormItem
                      required
                      number
                      margin
                      label="Monto"
                      name="monto"
                      type="number"
                      labelCol={{ xs: 7, sm: 7, lg: 14, xl: 14 }}
                      wrapperCol={{ xs: 17, sm: 17, lg: 12, xl: 12 }}
                      max={saldoPendiente}
                    >
                      <InputNumberItem dinero placeholder="Monto" />
                    </FormItem>
                  );
                }
                }
              </FormItem>
            </Col>
            <Col
              xs={{ span: 17, offset: 7 }}
              sm={{ span: 17, offset: 7 }}
              lg={{ span: 10, offset: 0 }}
              xl={{ span: 10, offset: 0 }}
            >
              <ButtonItem
                size="small"
                type="primary"
                cyan
                onClick={() => {
                  let tipoDeCambioVenta = this.formRef.current.getFieldValue('tipoDeCambioVenta')
                  let tipoDeCambioPago = this.formRef.current.getFieldValue('tipoDeCambioPago')
                  const pagarConNotas = this.formRef.current.getFieldValue('pagarConNotas')
                  const pagarConAnticipo = this.formRef.current.getFieldValue('pagarConAnticipo')
                  const pagarConAbono = this.formRef.current.getFieldValue('pagarConAbono')
                  const equivalencia = tipoDeCambioPago / tipoDeCambioVenta
                  let totalPagar = this.state.datosVenta?.totalPagar || 0;
                  let totalPagado =
                    this.state.datosVenta?.totalPagado || 0;

                  let saldoPendiente = round2Decimals(
                    (totalPagar - totalPagado) / equivalencia
                  );

                  if (pagarConNotas) {

                    const notaId = this.formRef.current.getFieldValue('notaId')

                    if (notaId) {

                      const notaCredito = this.state.notasDeCreditoPendiente.find((valueTodasNotas) => valueTodasNotas._id.toString() === notaId.toString())

                      this.formRef.current.setFieldsValue({
                        monto: Math.min(round2Decimals(notaCredito.totalPagar - notaCredito.totalPagado), saldoPendiente),
                      });

                    }

                  } else if (pagarConAnticipo) {
                    const anticipoId = this.formRef.current.getFieldValue('anticipoId')

                    if (anticipoId) {

                      const anticipo = this.state.anticiposPendientes.find((valueTodasAnticipos) => valueTodasAnticipos._id.toString() === anticipoId.toString())

                      this.formRef.current.setFieldsValue({
                        monto: Math.min(round2Decimals(anticipo.totalPagar - (anticipo.totalPagadoAnticipos || 0)), saldoPendiente),
                      });

                    }
                  } else if (pagarConAbono) {
                    const abonoId = this.formRef.current.getFieldValue('abonoId')

                    if (abonoId) {

                      const abono = this.state.abonosPendientesClientes.find((valueTodasAbonos) => valueTodasAbonos._id.toString() === abonoId.toString())
                      this.formRef.current.setFieldsValue({
                        monto: Math.min(round2Decimals(abono.monto - abono.totalPagadoAbono), saldoPendiente),
                      });
                    }
                  } else {
                    this.formRef.current.setFieldsValue({
                      monto: saldoPendiente,
                    });
                  }
                }
                }
              >
                Total
              </ButtonItem>
            </Col>
          </Row>
          <FormItem
            name="referencia"
            label="Referencia"
            margin
            pattern
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 15 }}
          >
            <InputItem placeholder="Referencia" />
          </FormItem>
        </Col>
      </Row>
    );
  }

  renderResumenCard() {
    const totalPagar = this.state.datosVenta?.totalPagar || 0;
    const totalPagado = this.state.datosVenta?.totalPagado || 0;
    const saldoPendiente = totalPagar - totalPagado;

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: 8,
          borderLeft: '4px solid #FF6A0D',
          borderTopLeftRadius: 8,
          borderBottomLeftRadius: 8,
          width: '100%',
          minWidth: 0,
          overflowX: 'auto',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '7px 8px',
            borderBottom: '1px dashed #d8d8d8',
          }}
        >
          <span style={{ color: '#666', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.4 }}>
            Total a Cobrar
          </span>
          <span style={{ color: '#333', fontSize: 15, fontWeight: 700 }}>
            {dineroDisabledMask(totalPagar)}
          </span>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '7px 8px',
            borderBottom: '1px dashed #d8d8d8',
          }}
        >
          <span style={{ color: '#666', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.4 }}>
            Total Cobrado
          </span>
          <span style={{ fontSize: 15, fontWeight: 700 }}>
            {dineroDisabledMask(totalPagado)}
          </span>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '14px 12px',
            marginTop: 12,
            boxShadow: '0 2px 6px rgba(131, 131, 131, 0.11)',
          }}
        >
          <span
            style={{
              fontSize: 12,
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: 0.5,
            }}
          >
            Saldo Pendiente
          </span>
          <span style={{ color: '#ff4d4f', fontSize: 18, fontWeight: 700 }}>
            {dineroDisabledMask(saldoPendiente)}
          </span>
        </div>
      </div>
    );
  }

  renderComplementoCard() {
    const labelCol = { span: 8 };
    const wrapperCol = { span: 16 };
    const colProps = { span: 24 };
    const tooltipNoEditable = (origen, descripcion) => ({
      // Icono outlined: el trazo (círculo y "?") toma el color y el interior queda blanco
      icon: (
        <QuestionCircleOutlined
          style={{
            color: "#00BFD6",
            background: "#ffffff",
            borderRadius: "50%",
            fontSize: 14,
          }}
        />
      ),
      title: (
        <span>
          <strong> Este campo no es editable aquí.</strong>{' '}
          {origen}
          <br /><br />
          {descripcion}
        </span>
      ),
    });
    return (
      <FormItem
        noStyle
        shouldUpdate={(prev, curr) =>
          prev.formaDePagoId !== curr.formaDePagoId ||
          prev.rfcEmisorCtaOrd !== curr.rfcEmisorCtaOrd
        }
      >
        {({ getFieldValue }) => {
          const requiereCuenta = this.requiereDatosCuenta(getFieldValue("formaDePagoId"));
          // Los datos del ordenante solo existen si hay una cuenta del cliente elegida
          const hayCuentaCliente = !!this.state.cuentaClienteSeleccionada;
          const activoOrdenante = requiereCuenta && hayCuentaCliente;
          // Si la forma de pago no permite datos de cuenta, se atenuan y no se envian
          const estiloInactivo = requiereCuenta ? undefined : { opacity: 0.45 };
          const estiloInactivoOrdenante = activoOrdenante ? undefined : { opacity: 0.45 };
          return (
            <Row gutter={[16, 0]}>
              <Col {...colProps} style={estiloInactivo}>
                <FormItem
                  label="Cuentas Cliente"
                  labelCol={labelCol}
                  wrapperCol={wrapperCol}
                  margin
                  tooltip="Selecciona una cuenta registrada para auto-rellenar los campos de abajo."
                >
                  <Input.Group compact>
                    <Select
                      style={{ width: "85%" }}
                      placeholder="Buscar en catálogo..."
                      showSearch
                      optionFilterProp="children"
                      value={this.state.cuentaClienteSeleccionada}
                      onChange={this.onSelectCuentaGuardada}
                      disabled={!requiereCuenta}
                      allowClear
                    >
                      {this.state.objetoCuentasCliente}
                    </Select>
                    <ButtonItem
                      cyan
                      icon={<PlusOutlined />}
                      style={{ width: "13%", marginLeft: "5px" }}
                      title="Agregar cuenta del cliente"
                      disabled={!requiereCuenta}
                      onClick={this.abrirAgregarCuentaCliente.bind(this)}
                    />
                  </Input.Group>
                </FormItem>
              </Col>
              <Col {...colProps}>
                <FormItem
                  label="Num Operacion"
                  name="numOperacion"
                  margin
                  labelCol={labelCol}
                  wrapperCol={wrapperCol}
                  tooltip={{ title: "Se puede registrar el número de cheque, número de autorización, número de referencia, clave de rastreo en caso de ser SPEI, línea de captura o algún número de referencia o identificación análogo que permita identificar la operación correspondiente al pago efectuado." }}
                >
                  <InputItem placeholder="Numero de Operacion" />
                </FormItem>
              </Col>
              <Col {...colProps} style={estiloInactivoOrdenante}>
                <FormItem
                  label="Cta Ordenante"
                  name="ctaOrdenante"
                  margin
                  labelCol={labelCol}
                  wrapperCol={wrapperCol}
                  tooltip={tooltipNoEditable(
                    "Se obtiene de la Cuenta Cliente seleccionada arriba. Para cambiarlo, elige otra cuenta o agrégala con el botón +.",
                    "Número de cuenta desde donde paga el cliente."
                  )}
                >
                  <InputItem disabled placeholder="Cuenta / CLABE" />
                </FormItem>
              </Col>
              <Col {...colProps} style={estiloInactivoOrdenante}>
                <FormItem
                  label="Rfc Ordenante"
                  name="rfcEmisorCtaOrd"
                  rfc
                  margin
                  labelCol={labelCol}
                  wrapperCol={wrapperCol}
                  tooltip={tooltipNoEditable(
                    "Se obtiene de la Cuenta Cliente seleccionada arriba. Para cambiarlo, elige otra cuenta o agrégala con el botón +.",
                    "Se puede registrar la clave en el RFC de la entidad operadora de la cuenta destino, es decir, la operadora, el banco, la institución financiera, emisor de monedero electrónico, etc."
                  )}
                >
                  <InputItem disabled placeholder="Rfc Emisor Cuenta Ordenante" />
                </FormItem>
              </Col>
              <Col {...colProps} style={estiloInactivoOrdenante}>
                {/* Regla CRP20223 del SAT: cuando el Rfc Ordenante es el RFC generico de banco
                    extranjero, el nombre del banco deja de ser opcional. Sin esto el rechazo
                    llega hasta el PAC, con el cobro ya armado y sin guardar. Solo aplica si hay
                    cuenta del cliente, porque sin ella los datos del ordenante no se envian. */}
                <FormItem
                  name="nomBancoOrdExt"
                  label="Banco Ordenante"
                  margin
                  pattern
                  required={
                    activoOrdenante &&
                    String(getFieldValue("rfcEmisorCtaOrd") || "").trim().toUpperCase() === "XEXX010101000"
                  }
                  labelCol={labelCol}
                  wrapperCol={wrapperCol}
                  tooltip={tooltipNoEditable(
                    "Se obtiene de la Cuenta Cliente seleccionada arriba. Para cambiarlo, elige otra cuenta o agrégala con el botón +.",
                    "Se puede registrar el nombre del banco ordenante, es requerido en caso de ser extranjero."
                  )}
                >
                  <InputItem disabled placeholder="Nombre Banco Ordenante" />
                </FormItem>
              </Col>
              <Col {...colProps} style={estiloInactivo}>
                <FormItem
                  label="Cta Beneficiario"
                  name="ctaBeneficiario"
                  number
                  max={50}
                  min={10}
                  margin
                  labelCol={labelCol}
                  wrapperCol={wrapperCol}
                  tooltip={tooltipNoEditable(
                    "Se obtiene de la configuración del banco elegido en Datos de Pago. Para modificarlo, edita ese banco desde Bancos → Editar Banco.",
                    "Se puede registrar el número de cuenta en donde se recibió el pago."
                  )}
                >
                  <InputItem disabled placeholder="Cuenta Beneficiario" />
                </FormItem>
              </Col>
              <Col {...colProps} style={estiloInactivo}>
                <FormItem
                  label="Rfc Beneficiaria"
                  name="rfcEmisorCtaBen"
                  rfc
                  margin
                  labelCol={labelCol}
                  wrapperCol={wrapperCol}
                  tooltip={tooltipNoEditable(
                    "Se obtiene de la configuración del banco elegido en Datos de Pago. Para modificarlo, edita ese banco desde Bancos → Editar Banco.",
                    "Se puede registrar la clave en el RFC de la entidad operadora de la cuenta destino, es decir, la operadora, el banco, la institución financiera, emisor de monedero electrónico, etc."
                  )}
                >
                  <InputItem disabled placeholder="Rfc Emisor Cuenta Beneficiaria" />
                </FormItem>
              </Col>
            </Row>
          );
        }}
      </FormItem>
    );
  }

  renderModalAgregarCuentaCliente() {
    return (
      <ModalItem
        title="Agregar Cuenta Cliente"
        visible={this.state.modalAgregarCuentaCliente}
        spinning={this.state.loadingCuentaCliente}
        onCancel={this.cerrarAgregarCuentaCliente.bind(this)}
        onOk={() => this.formRefCuentaCliente.current?.submit()}
        confirmLoading={this.state.loadingCuentaCliente}
        okText="Agregar"
        cancelText="Cancelar"
        footer
        width={520}
        destroyOnClose
      >
        <Alert
          type="info"
          showIcon
          message="Cuenta de pago del cliente"
          description="Se guardará en el catálogo de cuentas del cliente y podrás usarla para completar los datos del Complemento de Pago."
          style={{
            marginTop: 10,
            marginBottom: 16,
            borderRadius: 6,
            border: '1px solid #b8e8f0',
            background: 'linear-gradient(135deg, #f0fbfd 0%, #e6f7fa 100%)',
            fontSize: 13,
          }}
        />
        <Form
          ref={this.formRefCuentaCliente}
          name="agregarCuentaCliente"
          layout
          onFinish={this.onFinishCuentaCliente.bind(this)}
          onFinishFailed={this.onFinishFailedCuentaCliente}
        >
          <FormItem label="Descripción" name="descripcion" margin>
            <InputItem placeholder="Ej. BBVA Dólares" />
          </FormItem>
          <FormItem label="Banco (SAT)" name="bancoSatId" required margin>
            <SelectItem placeholder="Seleccionar Banco">
              {this.state.todasBancosSat?.map((value) => (
                <Option value={value._id} key={value._id}>
                  {value.clave + " - " + value.nombreCorto}
                </Option>
              ))}
            </SelectItem>
          </FormItem>
          <FormItem label="Cuenta / CLABE" name="cuenta" required margin pattern>
            <InputItem placeholder="10, 11 o 18 dígitos" />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }

  renderClienteInfoCard() {
    const cliente = this.state.datosVenta?.cliente;
    const proyecto = this.state.datosVenta?.proyecto;
    if (!cliente) return null;

    const clienteNombre = cliente.nombre
      ? <strong>{`${cliente.nombre} ${cliente.apellidoPaterno || ''} ${cliente.apellidoMaterno || ''}`.trim()}</strong>
      : <strong>{cliente.razonSocial || 'Cliente'}</strong>;

    const direccionItems = proyecto?.calle
      ? [
          { label: "Calle", value: proyecto.calle },
          { label: "Numero", value: proyecto.numeroCalle },
        ]
      : [
          { label: "Marca", value: proyecto?.marca },
          { label: "Modelo", value: proyecto?.modelo },
          { label: "Placas", value: proyecto?.placas },
        ];

    return (
      <Row>
        <InfoCard
          title="CLIENTE"
          icon={<UserOutlined />}
          iconColor="#00BFD6"
          accentColor="#00BFD6"
          compact
          sections={[
            {
              title: "Información",
              icon: <IdcardOutlined />,
              iconColor: "#00BFD6",
              lg: 6,
              items: [
                { label: "Nombre", value: clienteNombre },
                { label: "RFC", value: cliente.rfc },
                { label: "Correo", value: cliente.correo },
                { label: "Días Crédito", value: cliente.diasCredito ? `${cliente.diasCredito} días` : null },
              ],
            },
            {
              title: "Teléfonos",
              icon: <PhoneOutlined />,
              iconColor: "#FF6A0D",
              lg: 6,
              items: [
                { label: "Teléfono", value: cliente.telefono },
                { label: "Celular", value: cliente.celular },
              ],
            },
            {
              title: "Contacto",
              icon: <ContactsOutlined />,
              iconColor: "#C9DF00",
              lg: 6,
              items: [
                { label: "Persona", value: cliente.nombreContacto },
                { label: "Teléfono", value: cliente.telefonoContacto },
                { label: "Correo", value: cliente.correoContacto },
              ],
            },
            {
              title: proyecto?.calle ? "Dirección de Envío" : "Vehículo",
              icon: proyecto?.calle ? <EnvironmentOutlined /> : <CarOutlined />,
              iconColor: "#795548",
              lg: 6,
              items: [
                { label: "Proyecto", value: proyecto?.nombre },
                { label: "Descripción", value: proyecto?.descripcion },
                ...direccionItems,
              ],
            },
          ]}
        />
      </Row>
    );
  }

  render() {
    const isMobile = false;
    const abreviacionVenta = this.state.datosVenta?.moneda?.abreviacion || '-';

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Cobrar Venta"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '6px 14px',
                borderRadius: 6,
                fontSize: 14,
                fontWeight: 600,
              }}
            >
              <CalendarOutlined style={{ color: "#FF6A0D" }} />
              <span
                style={{
                  textTransform: 'uppercase',
                  fontSize: 11,
                  letterSpacing: 0.4,
                  color: "#FF6A0D"
                }}
              >
                Vencimiento:
              </span>
              <strong>
                {moment(this.state.datosVenta?.fechaPago).format("LL")}
              </strong>
            </div>
          }
        />
        <div
          style={{
              background: "linear-gradient(135deg, #f0fcfe 0%, #ffffff 100%)",
              padding: "16px 20px",
              marginBottom: 12,
              border: "1px solid #b5edf3",
              borderLeft: "5px solid #00BFD6",
              borderRadius: 6,
              display: "flex",
              gap: 12,
              boxShadow: "0 2px 8px rgba(0, 191, 214, 0.08)",
            }}

        >
          <FileTextOutlined style={{ color: "#00BFD6", fontSize: 18 }} />
          <span style={{ color: "#262626", fontWeight: "bold", fontSize: 16 }}>
            {this.state?.datosVenta?.serieNumero || ""}
          </span>
          <span style={{ color: "#d9d9d9", fontSize: 16 }}>|</span>
          <span style={{ color: "#262626", fontWeight: "bold", fontSize: 16 }}>
            {this.state.nombreCliente || "Cargando..."}
          </span>
        </div>
        {this.state.notasDeCreditoPendiente.length > 0 &&
          <Alert onClick={() => this.formRef.current.setFieldsValue({ pagarConNotas: true, pagarConAnticipo: false, pagarConAbono: false, anticipoId: undefined })} style={{ marginBottom: 10, cursor: 'pointer' }} description='Cambie a notas de credito para cobrar con una de ellas' showIcon message="Este cliente contiene notas de credito pendientes" type="warning" />
        }
        {this.state.anticiposPendientes.length > 0 &&
          <Alert style={{ marginBottom: 10 }} description='Los anticipos se aplican al crear la venta, en la pestaña Anticipos de Agregar Venta' showIcon message="Este cliente contiene anticipos pendientes" type="warning" />
        }
        {this.state.abonosPendientesClientes.length > 0 &&
          <Alert onClick={() => this.formRef.current.setFieldsValue({ pagarConAbono: true, pagarConNotas: false, pagarConAnticipo: false, abonoId: undefined })} style={{ marginBottom: 10, cursor: 'pointer' }} description='Cambie a abonos para cobrar con uno de ellos' showIcon message="Este cliente contiene abonos pendientes" type="warning" />
        }
       <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="cobrarVenta"
              layout
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              {this.state.datosVenta?.cliente && (
                <div style={{ padding: "0 16px", marginBottom: 16 }}>
                  {this.renderClienteInfoCard()}
                </div>
              )}

              <div style={{ padding: '0 16px' }}>
                <Row gutter={[16, 16]} align="top">       
                  <Col xs={24} sm={24} md={24} lg={24} xl={10} xxl={14}>
                    <Row gutter={[16, 16]}>
                      <DynamicCardForm
                        xs={24} sm={24} lg={24} xl={24}
                        colProps={{ xxl: 10 }}
                        noMargin
                        title={(
                          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                            Moneda
                          </span>
                        )}
                        headerRight={(
                          <div
                            style={{
                              textAlign: 'center',
                              padding: '2px 8px',
                              border: '1px solid #d0eaef',
                              borderRadius: 6,
                              fontSize: 10,
                              minWidth: 60,
                              minHeight: 28,
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <div style={{ fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.4, marginBottom: 1 }}>
                              Moneda Venta: <span>{abreviacionVenta}</span>
                            </div>
                          </div>
                        )}
                      >
                        {this.renderMonedaCard()}
                      </DynamicCardForm>

                      <DynamicCardForm
                        xs={24} sm={24} lg={24} xl={24}
                        colProps={{ xxl: 14 }}
                        noMargin
                        title={(
                          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                            Datos Complemento de Pago
                          </span>
                        )}
                      >
                        {this.renderComplementoCard()}
                      </DynamicCardForm>
                    </Row>
                  </Col>

                  <DynamicCardForm
                    xs={24} sm={24} lg={24} xl={14}
                    colProps={{ xxl: 10 }}
                    noMargin
                    title={(
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                        Datos de Pago
                      </span>
                    )}
                  >
                    {this.renderDatosPagoCard()}
                  </DynamicCardForm>
                </Row>
                <Row gutter={[16, 0]} justify="end" style={{ marginTop: 16 }}>
                  <Col xs={24} sm={24} md={12} lg={24} xl={14} xxl={10}>
                    {this.renderResumenCard()}
                  </Col>
                </Row>
              </div>

              <GeneralFormLayout
                isMobile={isMobile}
                actionButtons={
                  <Popconfirm
                    title={
                      this.state?.generaComplemento
                        ? "Se generara un complemento de pago"
                        : "Cobrar venta"
                    }
                    onConfirm={() => this.formRef.current.formRef.current.submit()}
                    okText="Ok"
                    cancelText="Cancelar"
                  >
                    <ButtonItem
                      type='primary'
                      cyanB
                      style={{ width: "5%" }}
                      onClick={() => {
                        //Cobrando con nota de credito, incobrable o ajuste de centavos no se timbra ningun complemento de pago
                        const values = this.formRef.current.formRef.current.getFieldsValue()
                        this.setState({
                          generaComplemento: !!(
                            this.state?.datosVenta?.factura &&
                            !this.state?.datosVenta?.cuentasXC &&
                            !values.pagarConIncobrable &&
                            !values.pagarConAjusteCentavos &&
                            !values.pagarConNotas
                          )
                        })
                      }}
                    >
                      Cobrar
                    </ButtonItem>
                  </Popconfirm>
                }
              />
            </Form>
          </Spin>
        </div>
        <MandarCorreoComplemento
          visible={this.state.modalCorreo}
          id={this.state.modalCorreoId}
          cerrarMandarCorreoComplemento={this.cerrarMandarCorreoComplemento.bind(this)}
        />
        <MandarCorreoPago
          visible={this.state.modalCorreoPago}
          id={this.state.modalCorreoId}
          cerrarMandarCorreoPago={this.cerrarMandarCorreoPago.bind(this)}
        />
        {this.renderModalAgregarCuentaCliente()}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(CobrarVenta);